<router-outlet></router-outlet>
<cc-list-tool-bar
  [selectedItemIds]="state.selectedListIds"
  [canDeployLists]="canDeployLists"
  (deleteSelectedItems)="onListsDelete(state.selectedListIds)"
  (deploySelectedItems)="onListsDeploy(state.selectedListIds, $event)"
  (createNewItem)="onSelectList('new')"
  *ngIf="lists.length"
>
</cc-list-tool-bar>

<div class="scrollable" *ngIf="!state.isLoading; else loadingState">
  <!-- Display records state -->
  <ng-container *ngIf="lists.length; else empty">
    <div
      class="container px-4 pt-4"
      [class.w-100]="lists.length < fullDisplayMode"
      [class.px-lg-0]="lists.length >= fullDisplayMode"
      [class.mx-lg-auto]="lists.length >= fullDisplayMode"
    >
      <cc-list-thumbnail
        class="mb-4 mr-sm-4"
        *ngFor="let list of lists"
        [list]="list"
        [listIsDeployed]="list.deployedParents?.includes(parentId)"
        [selected]="state.selectedListIds.includes(list.id)"
        (selectList)="onSelectList($event)"
        (changeSelectedState)="onChangeSelectedState($event.listId, $event.selected)"
      >
      </cc-list-thumbnail>
    </div>
  </ng-container>

  <!-- No records state -->
  <ng-template #empty>
    <div
      class="
        empty-list empty-state-container
        interim-state
        sm-relative sm-flex sm-flex-1 sm-justify-center sm-bg-cover
      "
    >
      <img class="img-responsive" src="./assets/images/lists-empty-state.png" />
      <h3 class="h3" i18n>No Lists</h3>
      <div>
        <button data-cy="new-list" class="btn btn-lg btn-success add-list" (click)="onSelectList('new')" i18n>
          Add List
        </button>
        <a
          class="btn btn-lg btn-outline-secondary"
          href="https://intercom.help/dashpivot/en/articles/2563225-lists"
          target="_blank"
          i18n
          >Learn more</a
        >
      </div>
    </div>
  </ng-template>
</div>

<!-- Loading state -->
<ng-template #loadingState>
  <div class="loading-spinner interim-state">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>
